import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { ACCESSORIES_PRICING_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class AccessoriesEUClient {
  static accessoriesUrl = ACCESSORIES_PRICING_URL;

  static getDealerAccessoriesData(user, lang, catalogIds, marketID = null) {
    const commonId = user.commonId.split("|").join("%7C");
    let url = `${this.accessoriesUrl}/dealer/accessories?dealerCommonId=${commonId}&catalogId=${catalogIds}`;
    if (lang) {
      url = url + `&lang=${lang}`;
    }

    if (marketID !== null) {
      url = url.concat(`&selectedMarket=${marketID}`);
    }
    return this.getAccessoriesData(user, url);
  }

  static getNscAccessoriesData(user, catalogIds, marketID) {
    const url = `${this.accessoriesUrl}/nsc/accessories?brandCode=${user.brand}&catalogId=${catalogIds}&selectedMarket=${marketID}`;

    return this.getAccessoriesData(user, url);
  }

  static getAccessoriesData(user, url) {
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data && response.data.result;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveNSCAccessories(user, data, catalogIds, marketID) {
    const url = `${this.accessoriesUrl}/nsc/accessories/save?brandCode=${user.brand}&catalogId=${catalogIds[0]}&selectedMarket=${marketID}`;

    return this.saveAccessories(user, data, url);
  }

  static saveDealerAccessories(user, commonIds, data, catalogIds) {
    const url = `${this.accessoriesUrl}/dealer/accessories/save?dealerCommonIds=${commonIds}&catalogId=${catalogIds[0]}`;
    return this.saveAccessories(user, data, url);
  }

  static saveAccessories(user, data, url) {
    return axios
      .post(url, data, getHeaders(user.token))
      .then((response) => response.status)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
